import { Investments } from '../../../investment/components/Investments';

export default function Investment() {
    return <Investments />;
}
